import { useEffect, useRef } from 'react'
import { Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useRouter } from '@/routing/navigation'
import { AnalyticsEvents, track } from '@/lib/services/analytics'

/**
 * Inline notice rendered in place of the chat composer after a trial user's
 * 6th send attempt is rejected by the backend (5-message cap per room).
 */
export function TrialMessageLimitNotice() {
  const router = useRouter()
  const viewedRef = useRef(false)

  useEffect(() => {
    if (viewedRef.current) return
    viewedRef.current = true
    track(AnalyticsEvents.TRIAL_LIMIT_REACHED, { limit: 'messages' })
  }, [])

  const handleUpgrade = () => {
    track(AnalyticsEvents.TRIAL_LIMIT_UPGRADE_PLANS_CLICKED, { limit: 'messages' })
    router.push('/settings/billing/plans')
  }

  return (
    <div className="shrink-0 px-4 pb-4" data-testid="trial-message-limit-notice">
      <div className="flex flex-col items-center gap-3 rounded-2xl bg-twin-chat-surface px-6 py-5">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-twin-chat-bubble/30 text-twin-chat-fg-muted">
          <Lock className="h-5 w-5" />
        </span>
        <p className="text-center text-base font-medium leading-snug text-twin-chat-fg">
          You&apos;ve hit the message limit for this chat
        </p>
        <p className="max-w-sm text-center text-sm leading-relaxed text-twin-chat-fg-muted">
          Trial conversations are limited to 5 messages per chat. Upgrade your
          plan to continue this conversation.
        </p>
        <Button
          variant="primary"
          size="sm"
          onClick={handleUpgrade}
          className="mt-1"
          data-testid="trial-message-limit-upgrade-cta"
        >
          Upgrade plan
        </Button>
      </div>
    </div>
  )
}
